import React from 'react';
import Button from '@boschebike/ebds-react/dist-esm/components/Button.js';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import { maintenanceImage } from '../../content/maintenance-image.js';

/**
 * @typedef {import('../../App.d.ts').ComponentMaintenancePageProps} ComponentMaintenancePageProps
 */
/**
 * @param {ComponentMaintenancePageProps} props
 */
export default ({
  headline,
  description,
  actionText,
  actionUrl,
}) => (
  <Container>
    <div
      data-testid="maintenance-page"
      className="dodo-maintenance-page"
    >
      <div className="dodo-maintenance-page__section__left">
        <h1>{headline}</h1>
        <p>{description}</p>
        {actionText || actionUrl ? (
          <div className="dodo-maintenance-page__actions">
            <Button
              mode={Button.modes.PRIMARY}
              text={actionText ?? 'Go back'}
              onClick={() => {
                location.href = actionUrl ?? '/';
              }}
            />
          </div>
        ) : null}
      </div>
      <div className="dodo-maintenance-page__section__right">
        <img
          src={maintenanceImage}
          alt="Maintenance"
        />
      </div>
    </div>
  </Container>
);
